import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const blurryBlob = cva('blurry-blob', {
  variants: {
    variant: {
      topLeft: '',
      bottomRight: '!top-auto !left-auto !-bottom-[10%] !right-0 rotate-180',
    },
  },
  defaultVariants: {
    variant: 'topLeft',
  },
});

interface BlurryBlobProps extends VariantProps<typeof blurryBlob> {
  className?: string;
}

export const GooFilter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="fixed top-0 left-0 w-0 h-0">
    <defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
        <feBlend in="SourceGraphic" in2="goo" />
      </filter>
    </defs>
  </svg>
);

const BlurryBlob = ({ className, variant }: BlurryBlobProps) => {
  return (
    <div className={cn(blurryBlob({ variant }), className)}>
      <div className="gradients-container">
        <div className="g1" />
        <div className="g2" />
        <div className="g3" />
        <div className="g4" />
      </div>
    </div>
  );
};

export default BlurryBlob;
